import { Component, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";

@Component({
  selector: "app-multi-field-cell-renderer",
  templateUrl: "./multi-field-cell-renderer.component.html",
  styleUrls: ["./multi-field-cell-renderer.component.scss"],
})
export class MultiFieldCellRendererComponent implements OnDestroy {
  params;
  list = [];
  private destroy$ = new Subject<void>();
  constructor() {}
  agInit(params: any): void {
    this.params = params;
    if (this.params.props) {
      this.list = this.params.props.map(item => {
        return this.params.data[item];
      })
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
